import { tv } from "@pcln/horizon";
const searchFormTabs = tv({
    slots: {
        root: '@container w-auto',
        content: 'mx-auto flex max-w-7xl flex-col justify-center gap-4 pt-0 pb-4 @min-3xl:mx-0',
        listFrame: 'flex w-full justify-center px-3 pt-1 @min-3xl:justify-start @min-3xl:px-0 @min-3xl:pt-0'
    }
});
export { searchFormTabs };
